<template>
  <fragment>
    <app-header title="Integrations">
      <template #actions>
        <router-link :to="{ name: 'settings.integrations.add' }" as="button" class="btn btn-primary">
          <i class="far fa-plus"></i> Integration
        </router-link>
      </template>
    </app-header>

    <integration-list :items="integrations">
      <template #archive="{ item }">
        <button type="button" class="btn btn-sm text-warning" @click="handleArchive(item)">
          <i class="far fa-trash-restore" v-if="item.archived"></i>
          <i class="far fa-archive" v-else></i>
        </button>
      </template>
    </integration-list>
  </fragment>
</template>
<script>
import { stateMapper, helperComputed, helperMethods } from '@/vuex/modules/settings/integrations'
import IntegrationList from '@/components/settings/IntegrationList'
import { call } from 'vuex-pathify'

export default {
  mixins: [
    stateMapper
  ],

  components: {
    IntegrationList
  },

  created () {
    this.getIntegrations()
  },

  computed: {
    ...helperComputed
  },

  methods: {
    ...helperMethods,
    restoreIntegration: call('settings/integrations/restoreIntegration'),

    async save () {
      // await this.storeMediaOwnerTag(this.mediaOwnerTag)
      // this.resetMediaOwnerTag()
      this.$refs.validation.reset()
    },

    async handleArchive (item) {
      if (item.archived) {
        await this.restoreIntegration(item)
        this.resetIntegration()
        this.getIntegrations({ fresh: true })
      } else {
        await this.deleteIntegration(item.id)
        this.getIntegrations({ fresh: true })
      }
    }
  }
}
</script>
